import React from "react";
import Homecomponent from "../components/home/Homecomponent";

// import Menu from "../components/menu";

function Home() {

  return (
    <>
    <Homecomponent />
    </>
  );
}

export default Home;
